<div
	class="row container-empresa-sucursal align-items-center m-0"
	[ngClass]="{
		'change-company-subsidiary': sucursalesOfSelectedEmisorSource.length > 1,
		'change-company-only': sucursalesOfSelectedEmisorSource.length <= 1
	}"
	style="min-width: 300px">
	<div
		[ngClass]="{
			'col-12': sucursalesOfSelectedEmisorSource.length <= 1,
			'col-8': sucursalesOfSelectedEmisorSource.length > 1
		}"
		class="p-1">
		<ng-select data-testid="company-selector" class="content-empresa custom-select-width" *ngIf="permissions.getPermission('60').asignado" [items]="emisoresSource" placeholder="Empresa" bindLabel="razonSocial" (change)="SetNewCompany()" [(ngModel)]="currentEmisorObject" [clearable]="false" style="width: 100%">
			<ng-template ng-option-tmp let-item="item">
				<div [attr.data-testid]="'company-option-' + item.emisorId" [attr.data-rut]="item.rut" title="{{ item.razonSocial }}">{{ item.razonSocial }}</div>
			</ng-template>
		</ng-select>
		<div *ngIf="!permissions.getPermission('60').asignado">
			<span>{{ currentEmisorObject.razonSocial }}</span>
		</div>
	</div>
	<div class="col-4 p-1" *ngIf="sucursalesOfSelectedEmisorSource.length > 1">
		<ng-select class="content-sucursal custom-select-width" [items]="sucursalesOfSelectedEmisorSource" placeholder="Sucursal" bindLabel="nombre" [clearable]="false" [(ngModel)]="currentSucursalObject" (change)="SetNewSubsidiary($event)" style="width: 100%"></ng-select>
	</div>
</div>

<swal #currentSwal icon="info" title="Cambio de Empresa" text=""></swal>
